import { useEffect } from "react";
import { useRegisterSW } from "virtual:pwa-register/react";
import { toast } from "sonner";

/**
 * Shows a toast when a new service worker version is waiting. Clicking
 * "Refresh" messages the SW to skipWaiting and reloads the page — avoids
 * mid-session chunk-mismatch errors from autoUpdate.
 */
export function ReloadPrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisterError(err) {
      console.warn("[pwa] SW registration failed:", err);
    },
  });

  useEffect(() => {
    if (!needRefresh) return;
    const id = toast("New version available", {
      description: "Refresh to get the latest updates.",
      duration: Infinity,
      action: {
        label: "Refresh",
        onClick: () => {
          updateServiceWorker(true);
        },
      },
      onDismiss: () => setNeedRefresh(false),
    });
    return () => {
      toast.dismiss(id);
    };
  }, [needRefresh, updateServiceWorker, setNeedRefresh]);

  return null;
}
